import { render } from "./RensponsiveGallery.vue?vue&type=template&id=123cbb70"
import script from "./RensponsiveGallery.vue?vue&type=script&lang=js"
export * from "./RensponsiveGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__